import moment from 'moment';

// Pure helpers for the shared DateRangePicker util. Deliberately free of any
// react/react-date-range import so they unit-test without a DOM (see utils.test.js).

// toApiDate: Date | string -> 'YYYY-MM-DD'
export const toApiDate = (date) => moment(date).format('YYYY-MM-DD');

// formatTriggerLabel: two YYYY-MM-DD strings -> 'MMMM D, YYYY - MMMM D, YYYY' (trigger button).
export const formatTriggerLabel = (start, end) => {
  if (!start || !end) return 'Select date range';
  return `${moment(start).format('MMMM D, YYYY')} - ${moment(end).format('MMMM D, YYYY')}`;
};

// formatFooter: two YYYY-MM-DD strings -> 'YYYY-MM-DD - YYYY-MM-DD' (popover footer).
export const formatFooter = (start, end) => {
  if (!start || !end) return '';
  return `${moment(start).format('YYYY-MM-DD')} - ${moment(end).format('YYYY-MM-DD')}`;
};

// PRESETS: sidebar quick ranges (matches the approved design). Each `range()`
// returns { startDate, endDate } Date objects; buildStaticRanges (in index.jsx)
// decorates these with react-date-range's isSelected via createStaticRanges.
export const PRESETS = [
  {
    label: 'Today',
    range: () => ({
      startDate: moment().startOf('day').toDate(),
      endDate: moment().endOf('day').toDate()
    })
  },
  {
    label: 'Yesterday',
    range: () => ({
      startDate: moment().subtract(1, 'days').startOf('day').toDate(),
      endDate: moment().subtract(1, 'days').endOf('day').toDate()
    })
  },
  {
    label: 'Last 7 Days',
    range: () => ({
      startDate: moment().subtract(6, 'days').startOf('day').toDate(),
      endDate: moment().endOf('day').toDate()
    })
  },
  {
    label: 'Last 30 Days',
    range: () => ({
      startDate: moment().subtract(29, 'days').startOf('day').toDate(),
      endDate: moment().endOf('day').toDate()
    })
  },
  {
    label: 'This Month',
    range: () => ({
      startDate: moment().startOf('month').toDate(),
      endDate: moment().endOf('day').toDate()
    })
  },
  {
    label: 'Last Month',
    range: () => ({
      startDate: moment().subtract(1, 'months').startOf('month').toDate(),
      endDate: moment().subtract(1, 'months').endOf('month').toDate()
    })
  }
];

// tillDatePreset: the "Till date" quick range — from tillDateStart (YYYY-MM-DD) when provided
// (used as-is even in future years), else the start of the current year, through today. Kept
// separate from PRESETS because its start is caller-configurable (index.jsx composes it in).
export const tillDatePreset = (tillDateStart) => ({
  label: 'Till date',
  range: () => ({
    startDate: tillDateStart
      ? moment(tillDateStart).startOf('day').toDate()
      : moment().startOf('year').toDate(),
    endDate: moment().endOf('day').toDate()
  })
});
